<template>
  <div class="apiStep-four" data-automation="apiStepFour">
    <div class="x-border-50 x-margin-b">
      <my-head-title :title="$t('HT.apiStepFour.text1')"></my-head-title>
      <div class="x-flex-justify x-padding">
        <ux-form
          ref="form"
          :data="formData"
          width="550px"
          :colon="true"
          :rules="rules"
          label-width="120px"
          :hideBtn="true"
        >
          <ux-form-item :label="$t('HT.apiStepFour.text2')" required prop="content_type">
            <ux-select v-model="formData.content_type" :options="$opt.contentType"></ux-select>
          </ux-form-item>
          <ux-form-item :label="$t('HT.apiStepFour.text3')" start prop="succeeded">
            <ux-input
              v-model="formData.succeeded"
              type="textarea"
              size="small"
              :autosize="{ minRows: 5, maxRows: 5 }"
            ></ux-input>
          </ux-form-item>
          <ux-form-item :label="$t('HT.apiStepFour.text4')" start prop="failed">
            <ux-input
              v-model="formData.failed"
              type="textarea"
              size="small"
              :autosize="{ minRows: 5, maxRows: 5 }"
            ></ux-input>
          </ux-form-item>
        </ux-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'apiStepThree',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          response: {
            content_type: '', // 响应Body类型
            succeeded: '', // 请求成功示例
            failed: '' // 请求失败示例
          }
        };
      }
    }
  },
  data() {
    return {
      formData: this.data.response,
      rules: this.$rul.addApi(),
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },

  methods: {
    /**
     * 验证回调
     */
    confirm() {
      return new Promise((resolve) => {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            resolve(this.formData);
          }
        });
      });
    },

    /**
     * 新增入参
     */
    addTable() {
      this.tableData.list.unshift({}); // 在数组数据前面加一个预留位置
    },

    /**
     * 移除当前入参
     */
    delTable(index) {
      this.tableData.list.splice(index, 1); // 移除当前入参
    }
  },

  watch: {
    data: {
      handler() {
        this.formData = this.data.response;
      },
      deep: true
    }
  }
};
</script>
